import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import { useQuestion } from "@/store/question.context";
import { RulerPen } from "iconsax-react";
import EvaluationCriteriaScore from "./evaluation-criteria-score";
import EvaluationFeedback from "./evaluation-feedback";

const wrapperClassName = "grid grid-cols-4 gap-4 items-start";

const EvaluationResults = () => {
  const { question } = useQuestion();

  if (!question) {
    return null;
  }

  const getCriteriaScoreByCriteriaId = (criteriaId: string) =>
    question.score?.criteriaScores.find(
      (score) => score.criteriaId === criteriaId,
    );

  return (
    <>
      <Separator />

      <section className="flex flex-col gap-4">
        <header>
          <div className="mr-2 inline-flex h-6 w-6 items-center justify-center rounded bg-[#9491CF] text-white">
            <RulerPen size={16} />
          </div>
          <span className="text-lg font-bold text-[#615CB7]">Evaluación</span>
        </header>

        {question.responseType && (
          <div className={wrapperClassName}>
            <h4 className="col-span-3 text-sm font-bold text-[#293038]">
              ¿La empresa cumplió con lo requerido?
            </h4>

            <div className="inline w-fit rounded bg-primary px-4 py-1 text-sm font-bold uppercase text-white">
              {question.responseType.name}
            </div>
          </div>
        )}

        <h4 className="text-sm font-bold text-[#293038]">Cuenta con:</h4>

        <div className="flex flex-col gap-3">
          {question.evaluationCriteria.map((evaluationCriteria) => (
            <EvaluationCriteriaScore
              key={evaluationCriteria.id}
              className={wrapperClassName}
              evaluationCriteria={evaluationCriteria}
              criteriaScore={getCriteriaScoreByCriteriaId(
                evaluationCriteria.id,
              )}
            />
          ))}

          <div className={cn(wrapperClassName, "mt-2 items-center")}>
            <div className="col-span-3 text-sm font-bold uppercase tracking-wide">
              Puntaje total de la pregunta
            </div>
            <div className="inline-flex max-w-32 rounded-lg border border-dashed border-[#3F3B87] bg-[#F2F2FF] p-3 text-sm">
              <span className="grow text-left font-semibold">
                {question.score?.score?.toFixed(2) ?? "-"}
              </span>
              <span className="text-[#8090A3]">/100</span>
            </div>
          </div>
        </div>

        {question.feedback && (
          <EvaluationFeedback feedback={question.feedback} />
        )}
      </section>
    </>
  );
};

export default EvaluationResults;
